var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chart',{attrs:{"chart-tooltip":_vm.chartTooltip,"chart-prompt":_vm.chartPrompt,"chart-id":_vm.elementId,"show-slider":_vm.isZoomEnabled},on:{"close-chart-prompt":_vm.onChartPromptClose},scopedSlots:_vm._u([{key:"meta",fn:function(){return [_c('double-chart-meta')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }